var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWriting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 35.3px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M239.9,91.8H95.1c-11,0-21.5,4.4-29.3,12.1s-12.1,18.3-12.1,29.3v289.6c0,11,4.4,21.5,12.1,29.3,7.8,7.8,18.3,12.1,29.3,12.1h289.6c11,0,21.5-4.4,29.3-12.1,7.8-7.8,12.1-18.3,12.1-29.3v-144.8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M395.1,60.7c8.2-8.2,19.4-12.9,31-12.9s22.8,4.6,31,12.9c8.2,8.2,12.9,19.4,12.9,31s-4.6,22.8-12.9,31l-196.5,196.5-82.8,20.7,20.7-82.8L395.1,60.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWriting);
export default __webpack_public_path__ + "static/media/writing.86de080f5e5c84b48a8564a4f284a1bb.svg";
export { ForwardRef as ReactComponent };